<pay-dialog-title>{{ config?.title | translate }}</pay-dialog-title>
<pay-dialog-body>
    <span
        [innerHTML]="config?.content | translate: config?.contentParams"
    ></span>
</pay-dialog-body>
<pay-dialog-actions class="justify-content-center">
    <button
        payButton
        type="button"
        class="c-btn--primary c-btn--lg c-btn--wlg"
        [disabled]="isBusy"
        (click)="process()"
    >
        {{ config?.btnText || 'Common.Ok' | translate }}
    </button>
</pay-dialog-actions>
